// Job user resume detail  ************************************************************************
// pathname: /v1/job/{jobSlug}/user-resume-detail/{slug}
// ************************************************************************************************
import { useSwrApi } from '@hooks/useSwrApi';

/** Props */
interface UseSwrJobUserResumeDetailProps {
  locale: Locale,
  jobSlug: string,
  userSlug: string,
  shouldFetch?: boolean,
  serverSideData?: ApiSchema<'ResumeData'>,
}

/**
 * @description SWR: fetch job suggested salary.
 * - `locale` - the current locale
 * - `payload` - the payload
 * - `shouldFetch` - condition for fetching the data. Default true.
 * - `successCallback` - success callback; works only on successful fetch
 * - `onDataChanged` - data changed callback; works on every data change (from cache or fetch)
 */
export const useSwrJobUserResumeDetail = (props: UseSwrJobUserResumeDetailProps) => {
  const {
    locale,
    jobSlug,
    userSlug,
    serverSideData,
    shouldFetch = true,
  } = props;

  return useSwrApi<ApiSchema<'ResumeData'>>({
    url: `/v1/job/${jobSlug}/user-resume-detail/${userSlug}`,
    locale,
    shouldFetch,
    serverSideData,
  });
};
